import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Result Set
function creatResultSet(params: any) {
    const baseUrl = `/resultSet/createRset`;
    return api.create(`${baseUrl}`, params);
}
// update Result Set
function updateResultSet(params: any) {
    const baseUrl = '/resultSet/updateRSet';
    return api.update(`${baseUrl}`, params);
}

// get all Result Sets
function getAllResultSets(params: any) {
    const baseUrl = '/resultSet/getAllRSet';
    return api.create(`${baseUrl}`, params);
}

// get Result Set Detail
function getResultSet(params: any) {
    const baseUrl = '/resultSet/getResultSetDetail';
    return api.create(`${baseUrl}`, params);
}

export { creatResultSet, updateResultSet, getAllResultSets, getResultSet };
